import { Outlet } from 'react-router-dom';
import { AiCopilotProvider } from './context/AiCopilotProvider';
import { AiCopilotDrawer } from './AiCopilotDrawer';

export function AiCopilotAppShell() {
  return (
    <AiCopilotProvider>
      <AiCopilotDrawer />
      <Outlet />
    </AiCopilotProvider>
  );
}
